// tiers.js — canonical maturity-tier identity for SecureShield365.
//
// Single source of truth for the five maturity tiers, mirroring getLevel() in
// SecureShield365.js so the dashboard, PDF (ExecutiveReport.js), and Excel
// (FindingsExport.js) never disagree on tier names/colors/descriptions.
//
// Framework-agnostic, plain JS, no imports. getLevel() uses theme tokens
// (T.green/T.yellow/T.orange/T.red); the hex equivalents are inlined here so
// this module is self-contained for the exports:
//   green=#53c46d, yellow=#f3b53f, orange=#ff7a45, red=#e14d57

export const TIERS = [
  { min: 90, level: 5, name: "Leading",    color: "#53c46d", desc: "Best-practice posture, low risk" },
  { min: 80, level: 4, name: "Excelling",  color: "#53c46d", desc: "Strong controls across core areas" },
  { min: 70, level: 3, name: "Advancing",  color: "#f3b53f", desc: "Solid controls, refining the details" },
  { min: 55, level: 2, name: "Developing", color: "#ff7a45", desc: "Basic protections in place, key gaps remain" },
  { min: 0,  level: 1, name: "Emerging",   color: "#e14d57", desc: "Core protections still forming — significant gaps to prioritize" },
];

export const getTier = (score) => TIERS.find((t) => score >= t.min) || TIERS[TIERS.length - 1];

// Ordered low→high for band rendering / captions.
export const TIER_NAMES_ASC = ["Emerging", "Developing", "Advancing", "Excelling", "Leading"];
